<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="title-line">
  <well-page-title title=" {{'company.subscription-type.add-title' | translate}}"></well-page-title>
</div>

<div class="row  my">
  <div class="p-field pb col-12 col-sm-6 col-lg-4">
    <ng-container [formGroup]="form">

      <div class="my">
        <div class="row">
          <div class="p-field pb col-12">
            <p-floatlabel variant="on">
              <input [ngStyle]="{'width': '100%'}" formControlName="typeName" formInlineError="company.subscription-type.errors" id="typeName"
                     pInputText type="text" data-testid="type-name-input">
              <label for="typeName">{{'company.subscription-type.inputs.typeName' | translate}} *</label>
            </p-floatlabel>
          </div>
        </div>
        <div class="row">
          <div class="p-field pb col-8">
            <p-floatlabel variant="on">
              <p-inputNumber
                     [maxFractionDigits]="2"
                     [useGrouping]="false"
                     class="w-100"
                     formControlName="subscriptionPrice"
                     formInlineError="company.subscription-type.errors"
                     id="subscriptionPrice"
                     inputStyleClass="w-100"
                     locale="en-US"
                     styleClass="w-100" data-testid="subscription-price-input">
              </p-inputNumber>
              <label
                for="subscriptionPrice">{{'company.subscription-type.inputs.subscriptionPrice' | translate}}
                *</label>
            </p-floatlabel>
          </div>

          <div class="p-field pb col-4">
            <p-floatlabel variant="on">
              <p-select [autoDisplayFirst]="false"
                          [options]="currencySelectItems"
                          class="w-100"
                          formControlName="subscriptionCurrency"
                          formInlineError="company.subscription-type.errors"
                          id="subscriptionCurrency"
                          inputStyleClass="w-100"
                          styleClass="w-100" data-testid="subscription-currency-select">

              </p-select>

              <label
                for="subscriptionCurrency">{{'company.subscription-type.inputs.subscriptionCurrency' | translate}}
                *</label>
            </p-floatlabel>
          </div>
        </div>
        <div class="row">
          <div class="p-field pb col-12">
            <p-floatlabel variant="on">
              <p-select [options]="companyTypeSelectItems"
                          [style]="{'width': '100%'}"
                          [readonly]='isEditMode()'
                          formControlName="companyType"
                          formInlineError="company.subscription-type.errors"
                          id="companyType" data-testid="company-type-select">
              </p-select>

               <label for="companyType">{{'company.subscription-type.inputs.companyType' | translate}}
                 *</label>
            </p-floatlabel>
          </div>
        </div>
        <div class="row">
          <div class="p-field pb col-12">
           <span class="">
             <label class="mr">{{'company.subscription-type.inputs.private' | translate}} </label>
             <p-toggleswitch formControlName="private" id="private" data-testid="private-toggle"></p-toggleswitch>

           </span>
          </div>
        </div>

        <div class="row">
          <div class="p-field pb col-12">
            <p-floatlabel variant="on">
              <p-inputNumber [maxFractionDigits]="0"
                             [useGrouping]="false"
                             class="w-100"
                             formControlName="creditStart"
                             formInlineError="company.subscription-type.errors"
                             id="creditStart"
                             inputStyleClass="w-100"
                             locale="en-US"
                             styleClass="w-100" data-testid="credit-start-input"></p-inputNumber>
              <label for="creditStart">{{'company.subscription-type.inputs.creditStart' | translate}} *</label>
            </p-floatlabel>
          </div>
        </div>

        <div class="row">
          <div class="p-field pb col-12">
            <p-floatlabel variant="on">
              <p-inputNumber [maxFractionDigits]="2"
                             [useGrouping]="false"
                             class="w-100"
                             formControlName="pricePerExtraCredit"
                             formInlineError="company.subscription-type.errors"
                             id="pricePerExtraCredit"
                             inputStyleClass="w-100"
                             locale="en-US"
                             styleClass="w-100" data-testid="price-per-extra-credit-input"></p-inputNumber>
              <label for="pricePerExtraCredit">{{'company.subscription-type.inputs.pricePerExtraCredit' | translate}}</label>
            </p-floatlabel>
          </div>
        </div>

        <div class="row">
          <div class="p-field pb col-12">
            <p-floatlabel variant="on">
              <textarea [ngStyle]="{'width': '100%'}" [rows]="8" formControlName="details" id="details"
                        pInputText type="text" data-testid="details-textarea">
              </textarea>
              <label for="details">{{'company.subscription-type.inputs.subscriptionDetails' | translate}} </label>
            </p-floatlabel>
          </div>
        </div>

      </div>

    </ng-container>
  </div>
</div>


